export const HotelCheckoutTabs = {
  GUEST_DETAILS: "GUEST_DETAILS",
  REVIEW: "REVIEW",
  CONFIRM: "CONFIRM",
};
